<template>
  <div class="rating">
    <h1>Tidigare provade öl</h1>
  </div>
</template>

<script>
export default {
  name: 'rating'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// ListBeers.vue?236ed868